import { CountrySelectorBootstrap } from './models/country-selector-bootstrap';

export const bootstrap: CountrySelectorBootstrap = (countrySelectorElements: JQuery) => {
  countrySelectorElements.each((_index: number, element: Element) => {
    const countrySelectorElement = element as HTMLSelectElement;
    const countryStatesJsonId = countrySelectorElement.getAttribute('states-json-id');
    if (!countryStatesJsonId) {
      return;
    }

    const countryStatesElement = document.getElementById(countryStatesJsonId);
    if (countryStatesElement === null) {
      return;
    }

    const countryStates: any[] = JSON.parse(countryStatesElement.innerHTML);
    const countryStatesListId = countrySelectorElement.getAttribute('states-list-id');
    let lastSelectedCountry: string;
    let lastSelectedCountryIndex: number;

    countryStatesElement.parentNode?.removeChild(countryStatesElement);
    const $countrySelectorElement: JQuery = $(`#${countrySelectorElement.getAttribute('id')}`);
    $countrySelectorElement.on('change', () => {
      const selectedCountry = countrySelectorElement.value;
      const countryWithStates = !!selectedCountry && countryStates.filter((countryWithStates: any) => countryWithStates.Value === selectedCountry)[0];

      if (lastSelectedCountry !== undefined) {
        countrySelectorElement.options[lastSelectedCountryIndex].value = lastSelectedCountry;
      }

      lastSelectedCountry = selectedCountry;
      lastSelectedCountryIndex = countrySelectorElement.selectedIndex;
      const countryStatesElements: JQuery = $(`#${countryStatesListId}`);
      const countryStatesValidationElements: JQuery = $(`[data-valmsg-for="${countryStatesListId}"]`);

      countryStatesElements.off().remove();
      countryStatesValidationElements.off().remove();
      
      if (!countryWithStates) {
        return;
      }

      const states = countryWithStates.States;
      let statesSelectorHtml = `
          <select 
              id="${countryStatesListId}" 
              required 
              class="jbr-form__input jbr-form__input--dropdown" 
              style="margin-top: 9px;" 
              name="${countryStatesListId}">
      `;
      statesSelectorHtml += '<option value>' + countrySelectorElement.getAttribute('states-list-empty-option') + '</option>';
      for (const state of states) {
        statesSelectorHtml += `<option value="${selectedCountry}-${state.IsoCode}">${state.Name}</option>`;
      }

      statesSelectorHtml += '</select>';
      $countrySelectorElement.after(statesSelectorHtml);

      const $countryStatesElement = $(`#${countryStatesListId}`);
      $countryStatesElement.on('change', function() {
        const countryStatesElementValue: string = $countryStatesElement.val() as string;
        if (countryStatesElementValue === '') {
          countrySelectorElement.options[countrySelectorElement.selectedIndex].value = selectedCountry;
        } else {
          countrySelectorElement.options[countrySelectorElement.selectedIndex].value = countryStatesElementValue;
        }
      });

      const statesSelectorValidationHtml = `<span class="field-validation-valid" data-valmsg-for="${countryStatesListId}" data-valmsg-replace="true"></span>`
      $countryStatesElement.after(statesSelectorValidationHtml);
    });

    // Trigger change event because country list could be pre-selected from Sitecore.
    $countrySelectorElement.trigger('change');
  });
};
